module.exports = __webpack_public_path__ + "static/media/fly0284.3426a251.webp";